import { render, staticRenderFns } from "./DeliveryConfirm.vue?vue&type=template&id=c1cbd9a6&scoped=true&"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryConfirm.vue?vue&type=style&index=0&id=c1cbd9a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cbd9a6",
  null
  
)

export default component.exports